<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="600">
    <template v-slot:title>Copy Staff</template>
    <v-row>
      <v-col
        ><v-text-field
          v-model="newUsername"
          label="New Username"
          :outlined="outlinedInputs"
          hide-details
        ></v-text-field
      ></v-col>
      <v-col
        ><v-text-field
          v-model="newName"
          label="New name"
          :outlined="outlinedInputs"
          hide-details
        ></v-text-field
      ></v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          v-model="newEmail"
          label="New Email"
          :outlined="outlinedInputs"
          hide-details
        ></v-text-field>
      </v-col>
      <v-col
        ><v-text-field
          v-model="newPass"
          label="New Password"
          :disabled="randomPass"
          :outlined="outlinedInputs"
          hide-details
        ></v-text-field
      ></v-col>
    </v-row>
    <v-row>
      <v-col class="py-0">
        <v-switch v-model="randomPass" label="Generate Random Pass"></v-switch>
      </v-col>
    </v-row>
    <template v-slot:actions>
      <v-btn
        color="primary"
        :disabled="!isValid || inProgress"
        @click="onSave"
        >{{ inProgress ? "Please wait..." : "Copy" }}</v-btn
      >
    </template>
  </basic-dialog>
</template>

<script>
import gql from "graphql-tag";
import BasicDialog from "../shared/BasicDialog";
const CLONE_STAFF = gql`
  mutation cloneStaff($input: CloneStaffInput!) {
    cloneStaff(input: $input) {
      id
      username
    }
  }
`;
export default {
  name: "clone-staff",

  props: {
    show: {
      type: Boolean,
      default: () => true,
    },
    value: {
      type: Object,
      default: () => null,
    },
  },

  components: {
    BasicDialog,
  },

  data() {
    return {
      inProgress: false,
      newUsername: this.value ? `${this.value.username} copy` : "New userame",
      newName: this.value ? `${this.value.name} copy` : "New name",
      newEmail: this.value ? `${this.value.email}` : "new@email.com",
      newPass: "",
      randomPass: true,
    };
  },

  computed: {
    isValid() {
      return this.newName != "" && this.value && this.value.id != "";
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  watch: {
    value(newVal) {
      this.newUsername = `${newVal.username} copy`;
      this.newName = `${newVal.name} copy`;
      this.newEmail = `copy-${newVal.email}`;
    },
  },

  methods: {
    onSave() {
      const input = {
        id: this.value.id,
        newName: this.newName,
        newUsername: this.newUsername,
        newPass: this.randomPass ? null : this.newPass,
        newEmail: this.newEmail,
      };
      this.cloneStaff(input);
    },
    async cloneStaff(input) {
      this.inProgress = true;
      try {
        const result = await this.$apollo.mutate({
          mutation: CLONE_STAFF,
          variables: { input },
        });
        //console.log(result);
        if (result.data.cloneStaff.id) {
          this.$emit("complete", { ...result.data.cloneStaff });
        }
        this.inProgress = false;
      } catch (error) {
        this.inProgress = false;
        console.log(error);
        const errorMsg = error.graphQLErrors.map((e) => e.message).join(", ");
        this.$store.dispatch("showAppSnackbar", {
          msg: errorMsg,
          color: "error",
        });
      }
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/agents/CloneStaff.vue